import script from "./UserInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&setup=true&lang=js"

import "../../assets/css/pc/account.css?vue&type=style&index=0&id=3d4f018a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4f018a"]])

export default __exports__